export const languageSelector = store => store.language;
